import { acceptUpdate, changes, rejectUpdate } from './requests'

export const addDecisionButtons = () => {
  const s = document.getElementById('overviewTable').parentNode;
  // const header3 = document.getElementById('overviewHeaderTh');

  const db = document.createElement('div');
  db.id = 'decisionButtons';

  // Reject all
  const rejectAllBtn = document.createElement('button');
  rejectAllBtn.id = 'rejectAllBtn';
  rejectAllBtn.title = 'Avvis alle endringer';
  rejectAllBtn.className = 'btn-floating waves-effect waves-light red';
  rejectAllBtn.innerHTML = '<i class="material-icons custom-i">clear</i>';
  rejectAllBtn.onclick = uncheckAll;
  db.appendChild(rejectAllBtn);

  // Reset all choices to indeterminate
  const allIndeterminateBtn = document.createElement('button');
  allIndeterminateBtn.id = 'allIndeterminateBtn';
  allIndeterminateBtn.title = 'Nullstill alle valg';
  allIndeterminateBtn.className = 'btn-floating waves-effect waves-light grey';
  allIndeterminateBtn.innerHTML = '<i class="material-icons custom-i">remove</i>';
  allIndeterminateBtn.onclick = indeterminateAll;
  db.appendChild(allIndeterminateBtn);

  // Approve all
  const approveAllBtn = document.createElement('button');
  approveAllBtn.id = 'approveAllBtn';
  approveAllBtn.title = 'Alle endringer kvalitetssikres';
  approveAllBtn.className = 'btn-floating waves-effect waves-light green';
  approveAllBtn.innerHTML = '<i class="material-icons custom-i">done_all</i>';
  approveAllBtn.onclick = checkAll;
  db.appendChild(approveAllBtn);

  // Submit all choices
  const submitAllBtn = document.createElement('button');
  submitAllBtn.id = 'submitAllBtn';
  submitAllBtn.type = 'submit';
  submitAllBtn.title = 'Lagre kvalitetssikring';
  submitAllBtn.className = 'btn-floating btn-large waves-effect waves-light blue';
  submitAllBtn.innerHTML = '<i class="material-icons custom-i">send</i>';
  // submitAllBtn.className = 'btn waves-effect waves-light blue';
  // submitAllBtn.innerHTML = 'Lagre<i class="material-icons">save</i>';
  submitAllBtn.onclick = submitAll;
  db.appendChild(submitAllBtn);

  s.appendChild(db);
  // s.appendChild(createBackgroundLayersBtn());
};

export function createApprovalBtn(index) {
  const approvalBtn = document.createElement('button');
  approvalBtn.id = 'approvalBtn' + index;
  approvalBtn.type = 'submit';
  approvalBtn.title = 'Kvalitetssikret';
  approvalBtn.className = 'btn waves-effect waves-light blue approval hide';
  approvalBtn.innerHTML = 'Kvalitetssikret';
  approvalBtn.onclick = () => acceptUpdate(index);
  return approvalBtn;
}

export function createRejectionBtn(index, disabled) {
  const rejectionBtn = document.createElement('button');
  rejectionBtn.id = 'rejectionBtn' + index;
  rejectionBtn.type = 'submit';
  rejectionBtn.title = 'Avvis';
  rejectionBtn.className = 'btn waves-effect waves-light blue rejection hide';
  rejectionBtn.innerHTML = 'Avvis';
  rejectionBtn.onclick = () => rejectUpdate(index);
  rejectionBtn.disabled = disabled;
  return rejectionBtn;
}

export function getStateIndex(cb) {
  if (cb.indeterminate) { return 0; }
  else if (cb.checked) { return 1; }
  else { return 2; }
}

export function showSubmitBtn(e) {
  // console.log(this.indeterminate);
  // console.log(e);
  const a = document.getElementById('approvalBtn' + this.value);
  const r = document.getElementById('rejectionBtn' + this.value);
  if(this.indeterminate) {
    if (a.className.slice(-4) !== 'hide') { a.className = a.className + ' hide'; }
    if (r.className.slice(-4) !== 'hide') { r.className = r.className + ' hide'; }
  } else if(this.checked) {
    if (a.className.slice(-4) === 'hide') {
      a.className = a.className.slice(0, -5); // remove hide
    }
    if (r.className.slice(-4) !== 'hide') { r.className = r.className + ' hide'; }
  } else {
    if (a.className.slice(-4) !== 'hide') { a.className = a.className + ' hide'; }
    if (r.className.slice(-4) === 'hide') {
      r.className = r.className.slice(0, -5); // remove hide
    }
  }
}

function uncheckAll() {
  setAllCheckboxesTo(false, false);
}
function indeterminateAll() {
  setAllCheckboxesTo(false, true);
}
function checkAll() {
  setAllCheckboxesTo(true, false);
}
function setAllCheckboxesTo(checkState, indeterminateState) {
  const l = changes.length;
  for (let i = 1; i <= l; i++) {
    const cb = document.getElementById('change#' + i);
    if (cb && !overviewBody.rows[i - 1].hidden) {
      cb.indeterminate = indeterminateState;
      cb.checked = checkState;
      // cb.onchange();
      cb.data.changedAllCheckboxes = true;
      cb.data.state = { indeterminate: indeterminateState, checked: checkState };
    }
  }
}

function submitAll() {
  const l = changes.length;
  for (let i = 1; i <= l; i++) {
    const cb = document.getElementById('change#' + i);
    if (cb.indeterminate) continue;
    else if (cb.checked) acceptUpdate(i);
    else if (!cb.dataset.jf23) rejectUpdate(i); // jan_feb_2023 cannot be reset
  }
  // closeOverview();
}

// Workaround for changes in January and February 2023 which were not logged:
export const jan_feb_2023 = (jsonString) => {
  const json = JSON.parse(jsonString);
  const p = json.features[0].properties;
  const od = new Date(p.felles_egenskaper.oppdateringsdato);
  const jan1 = new Date(2023, 0, 1);
  const feb28 = new Date(2023, 1, 28, 23, 59);
  return jan1 < od && od < feb28;
};
